import { createV3Queries } from "@query/utils/createV3Queries";
import { onboardingApi } from "@api";

export const queriesOnboarding = createV3Queries(
  "onboardingApi",
  onboardingApi,
  {
    // Both reads error while the account has no ComplianceEntity yet; consumers
    // treat an error as "verification not started", so never retry-loop on it.
    getOnboardingStatus: () => ({ retry: false }),
    getMissingFields: () => ({ retry: false }),
    triggerVerification: queries => ({
      dependencies: () => [
        queries.getOnboardingStatus.queryKeyBase,
        queries.getMissingFields.queryKeyBase
      ]
    })
  }
);
